import React from 'react';
import { Container, Typography } from '@mui/material';

function Contact() {
  return (
    <Container>
      <Typography variant="h2">Contact Page</Typography>
      <Typography variant="body1">Get in touch with us here.</Typography>
    </Container>
  );
}

export default Contact;
